export default {
  link: '#6e00ff',
  visitedLink: '#420099',
  background: '#f7f7f8',
  text: '#433050',
  navbarBorder: '#c2afcf'
}



// WEBPACK FOOTER //
// ./src/styles/colors.js